var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.473,
    height: 324.116,
    viewBox: "0 0 204.473 324.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-430.729 -366.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M635.183,468.86c-.529,28.029-10.1,52.477-30.2,72.444-8.991,8.935-18.009,17.842-26.916,26.86-20.161,20.43-30.423,44.962-30.581,73.743-.074,11.885-11.106,18.816-21.2,13.518-5.511-2.885-7.627-7.747-7.58-13.8.278-33.522,11.18-63.082,33.735-87.9,11.514-12.665,24.411-24.068,36.055-36.63,9.12-9.835,14.455-21.943,16.9-35.155a72.774,72.774,0,0,0-5.984-45.658,66.959,66.959,0,0,0-23.928-27.667c-1.271-.816-2.4-1.846-3.6-2.774-16.255-9.13-33.513-12.98-52.023-9.492-20.969,3.962-37.057,15.253-48.664,33.067a71.39,71.39,0,0,0-11.523,38.04c-.436,17.424,5.186,32.78,15.652,46.53.733.974,1.345,2.041,2.023,3.062.084,1.178.427,2.106,1.846,2.088h.037c11.356,10.1,4.593,23.26-4.7,25.357-6.4,1.447-11.394-.789-15.559-5.521-5.79-4.453-9.631-10.531-13.147-16.682-11.152-19.484-16.617-40.416-14.715-62.98,1.457-17.248,7.265-32.975,16.459-47.615a87.927,87.927,0,0,1,17.257-20.152,103.915,103.915,0,0,1,33.6-19.531,105.505,105.505,0,0,1,32.084-5.938c20.514-.584,39.284,5.177,56.7,15.736.585.362.872,1.215,1.29,1.837,8.675,4.045,15.439,10.549,21.488,17.656C626.5,420.716,635.675,443.132,635.183,468.86Z",
    transform: "translate(0 0)",
    fill: "#fa6400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M483,531.046h-.037c0-.018-.009-.028-.009-.046Z",
    transform: "translate(-3.77 -11.908)",
    fill: "#e68b35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M453.877,592.253c3.329,8.553,6.67,16.684,9.627,24.954,1.2,3.36,2.273,3.143,4.558,1.044,2.952-2.713,6.128-5.193,9.308-7.643,1.68-1.3,2.043-2.432,1.4-4.654-1.232-4.278-1.969-8.8,2.681-12.447,1.1,2.19,2.115,4.179,3.1,6.181.875,1.773,1.09,4.445,4.289,2.539.847-.5,2.161.8,2.009,1.4-1.424,5.625,3.839,4.9,6.294,6.8.7.543,1.49.973,2.3,1.492-1.42,2.083-2.942,3.456-5.488,2.733-7.227-2.052-11.917.858-16.088,6.87-4.962,7.152-5.4,6.829,2.841,9.991,6.718,2.576,13.423,5.189,20.232,7.824-2.372,3.624-5.033,4.852-8.921,3.908-4.337-1.052-8.838-1.414-13.2-2.371-3.067-.673-5.55-.8-7.807,2.048-2.179,2.747-4.062.672-4.72-1.429-1.134-3.617-1.975-4.1-4.87-1.474-2.978,2.7-5.809,5.589-9.259,7.688-2.846,1.731-6.595,4.932-9.1,2.456-2.532-2.5.618-6.289,2.5-8.977,2.3-3.275,5.083-6.2,7.587-9.336,1.754-2.2,4.272-4.4-1.373-5.032-2.7-.3-3.978-2.678-1.176-4.915,2.45-1.956,2.54-4.12,1.9-6.944-1.022-4.505-1.205-9.224-2.466-13.646C448.9,597.3,450.349,594.893,453.877,592.253Z",
    transform: "translate(-0.822 -16.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M554.05,698.8c-.223,9-5.732,14.44-14.475,14.3-8.2-.127-13.92-6.393-13.846-15.171a14.3,14.3,0,0,1,14.449-13.862C548.343,684.259,554.255,690.536,554.05,698.8Z",
    transform: "translate(-6.857 -22.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M483,531.046h-.037c0-.018-.009-.028-.009-.046Z",
    transform: "translate(-3.77 -11.908)",
    fill: "#722687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M600.037,473.636c-.154,2.161.347,4.6-2.4,4.421-3.372-.215-2.6-3.143-2.715-5.3-.1-1.822-.3-4.135,2.36-4.015C600.823,468.9,599.461,472.066,600.037,473.636Z",
    transform: "translate(-11.849 -7.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M597.98,491.808c-1.235,1.857-.016,5.582-3.894,5.634a2.168,2.168,0,0,1-2.066-3.235c.916-2.166.158-5.748,3.851-5.891C597.834,488.241,598.144,489.967,597.98,491.808Z",
    transform: "translate(-11.625 -8.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M589.724,509.127c-1.1,2.03-1.948,4.813-5.071,5.389a2.006,2.006,0,0,1-2.51-2.418c.84-2.565,2.152-5.248,5.088-5.966C588.672,505.781,589.733,507.02,589.724,509.127Z",
    transform: "translate(-10.923 -10.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M548.557,551.4c-1.216,2.272-2.69,4.577-5.573,5.29a2.073,2.073,0,0,1-2.641-2.339,7.915,7.915,0,0,1,5.473-5.541C547.381,548.335,548.321,549.532,548.557,551.4Z",
    transform: "translate(-7.909 -13.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M489.618,458.336c-1.278,1.645.01,5.47-3.94,5.405-2.173-.036-2.4-1.889-1.887-3.335.776-2.19.083-5.706,3.9-5.679C489.746,454.742,489.943,456.392,489.618,458.336Z",
    transform: "translate(-3.814 -6.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M559.516,534.775c2.069-.064,3.208.942,2.856,2.456a7.341,7.341,0,0,1-5.448,5.479,1.982,1.982,0,0,1-2.518-2.386C555.089,537.534,557.282,535.871,559.516,534.775Z",
    transform: "translate(-8.923 -12.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M548.9,422.721c-1.987-.648-5.4.243-5.774-3.368-.2-1.93,2.066-2.277,3.371-1.966,2.211.528,5.788-.855,6,3.212C552.613,422.743,550.856,422.812,548.9,422.721Z",
    transform: "translate(-8.113 -3.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M494.343,446.2c-1.586-.384-2.875-1.3-2.4-2.821.815-2.581,2.047-5.209,5.142-5.7a2,2,0,0,1,2.354,2.565A9.057,9.057,0,0,1,494.343,446.2Z",
    transform: "translate(-4.412 -5.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M489.225,502.518c-3.136-.737-3.345-3.8-4.141-6.254a2.107,2.107,0,0,1,2.179-2.817c3.743.239,3.316,3.851,4.316,6.155C492.2,501.023,491.132,502.187,489.225,502.518Z",
    transform: "translate(-3.915 -9.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M502.859,516.017c-.18,1.666-.857,2.779-2.359,2.514-3.059-.539-4.66-2.906-5.5-5.558a1.966,1.966,0,0,1,2.476-2.455C500.389,511.221,501.852,513.6,502.859,516.017Z",
    transform: "translate(-4.632 -10.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M508.759,432.434c-1.916-.4-3.3-1.131-2.9-2.765.739-3.027,3.439-4.1,6.074-4.737a2.012,2.012,0,0,1,2.436,2.5C513.814,430.722,510.291,430.621,508.759,432.434Z",
    transform: "translate(-5.418 -4.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M529.172,570.706c-2.043,0-2.988-.982-2.662-2.321a7.126,7.126,0,0,1,5.5-5.517,1.953,1.953,0,0,1,2.412,2.505A8.2,8.2,0,0,1,529.172,570.706Z",
    transform: "translate(-6.909 -14.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M486.754,478.673c-.215,1.925.72,4.669-2.368,4.649-3.223-.02-2.565-2.859-2.64-4.912-.071-1.972-.453-4.531,2.577-4.364C487.24,474.207,486.527,476.848,486.754,478.673Z",
    transform: "translate(-3.679 -7.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M576.486,523.056c-.1,1.986-4.437,5.988-6.042,5.753a2.332,2.332,0,0,1-2.126-2.533c-.018-1.845,4.288-5.707,6.038-5.471A2.193,2.193,0,0,1,576.486,523.056Z",
    transform: "translate(-9.932 -11.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M515.218,584.815c-2.027-.074-2.706-1.024-2.473-2.451a6.51,6.51,0,0,1,5.361-5.523,1.944,1.944,0,0,1,2.379,2.523A9.487,9.487,0,0,1,515.218,584.815Z",
    transform: "translate(-5.917 -15.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M565.148,422.373c2.131,1.269,5.545,1.241,5.985,4.674a2.1,2.1,0,0,1-2.732,2.282c-2.439-.938-5.691-1.318-6.226-4.634C561.917,423.09,563.426,422.437,565.148,422.373Z",
    transform: "translate(-9.486 -4.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M526.565,423.667c-1.831-.06-3.127-.842-2.733-2.489.873-3.656,4.353-2.506,6.773-3.179,1.766-.49,2.649.886,2.391,2.394C532.315,424.372,528.723,422.861,526.565,423.667Z",
    transform: "translate(-6.715 -3.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M596.328,455.261c.257,2.235-.9,3.553-2.209,3.376-3.489-.469-3.505-3.835-4.247-6.333a1.959,1.959,0,0,1,2.371-2.537C595.542,450.313,595.173,453.643,596.328,455.261Z",
    transform: "translate(-11.48 -6.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M581.171,433.876a8.745,8.745,0,0,1,4.97,5.457c.414,1.192-.855,2.16-2.265,2.23-1.5.074-5.636-4.392-5.444-5.966C578.577,434.417,579.336,433.722,581.171,433.876Z",
    transform: "translate(-10.661 -4.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M501.128,598.765c-2.384-.086-2.825-1.354-2.457-2.563.836-2.744,2.54-4.962,5.551-5.412,1.806-.27,2.489,1.27,2.072,2.743C505.479,596.408,503.068,597.738,501.128,598.765Z",
    transform: "translate(-4.896 -16.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M482.856,530.886c-1.447.042-1.807-.9-1.887-2.089Z",
    transform: "translate(-3.627 -11.749)",
    fill: "#722687"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerMark);
export default __webpack_public_path__ + "static/media/banner-mark.e29c4030654d5049090daed66b162087.svg";
export { ForwardRef as ReactComponent };